var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    stroke: "#BDBDBD",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2246 15.5454H9.52148V15.1177C9.62305 15.1099 9.72266 15.1001 9.82031 15.0884C9.91797 15.0767 10.002 15.0571 10.0723 15.0298C10.1973 14.9829 10.2852 14.9165 10.3359 14.8306C10.3867 14.7407 10.4121 14.6235 10.4121 14.479V11.0688C10.4121 10.9321 10.3809 10.813 10.3184 10.7114C10.2559 10.606 10.1777 10.522 10.084 10.4595C10.0137 10.4126 9.90625 10.3677 9.76172 10.3247C9.62109 10.2817 9.49219 10.2544 9.375 10.2427V9.81494L12.2461 9.6626L12.334 9.75049V14.4028C12.334 14.5396 12.3633 14.6567 12.4219 14.7544C12.4805 14.8481 12.5645 14.9185 12.6738 14.9653C12.752 15.0005 12.8379 15.0317 12.9316 15.0591C13.0254 15.0864 13.123 15.106 13.2246 15.1177V15.5454ZM12.3691 7.55322C12.3691 7.8501 12.2539 8.104 12.0234 8.31494C11.7969 8.52197 11.5273 8.62549 11.2148 8.62549C10.8984 8.62549 10.625 8.52197 10.3945 8.31494C10.168 8.104 10.0547 7.8501 10.0547 7.55322C10.0547 7.25635 10.168 7.00244 10.3945 6.7915C10.625 6.58057 10.8984 6.4751 11.2148 6.4751C11.5312 6.4751 11.8027 6.58057 12.0293 6.7915C12.2559 7.00244 12.3691 7.25635 12.3691 7.55322Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.b759dee5c5abb43f4ec0c79b5952da0f.svg";
export { ForwardRef as ReactComponent };